"use strict";

exports.__esModule = true;
exports.PointValue = void 0;
var _react = _interopRequireDefault(require("react"));
var _approximateFontSize = require("../approximateFontSize");
var _calculateXY2 = require("../calculateXY");
var _constants = require("../../constants");
var _excluded = ["width", "height", "value"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var parseValueToPoint = function parseValueToPoint(value) {
  var parts = value ? value.split(/\s+/) : ["", "", ""];
  return {
    x: formatPointValue(parts[0]),
    y: formatPointValue(parts[1]),
    z: formatPointValue(parts[2])
  };
};
var formatPointValue = function formatPointValue(input) {
  var value = parseFloat(input) || 0;
  if (value < 1) {
    return (Math.round(value * 100) / 100).toString();
  }
  if (value < 10) {
    return (Math.round(value * 10) / 10).toString();
  }
  return Math.round(value).toString();
};
var renderTspanPair = function renderTspanPair(fontSize, smallFontSize, mainValue, dimension) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("tspan", {
    fontSize: fontSize,
    fontWeight: "bold",
    alignmentBaseline: "middle"
  }, mainValue), /*#__PURE__*/_react["default"].createElement("tspan", {
    fontSize: smallFontSize,
    alignmentBaseline: "mathematical"
  }, dimension));
};

/**
 * Displays a point in space identified by X, Y, and Z positions and
 * represented by a space-delimited set of numbers each expressed in millimeters.
 */
var PointValue = exports.PointValue = function PointValue(props) {
  var width = props.width,
    height = props.height,
    value = props.value,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var point = parseValueToPoint(value);
  var fontSize = (0, _approximateFontSize.approximateFontSize)({
    width: width,
    height: height,
    value: point.x + " " + point.y + " " + point.z
  });
  var smallFontSize = Math.floor(fontSize * 0.3);
  var _calculateXY = (0, _calculateXY2.calculateXY)({
      width: width,
      height: height
    }),
    x = _calculateXY.x,
    y = _calculateXY.y;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: width,
    height: height
  }, extra, {
    "data-testid": "PointValue"
  }), /*#__PURE__*/_react["default"].createElement("text", {
    x: x,
    y: y,
    textAnchor: _constants.TEXT_ANCHOR_MIDDLE
  }, renderTspanPair(fontSize, smallFontSize, point.x, "X"), " ", renderTspanPair(fontSize, smallFontSize, point.y, "Y"), " ", renderTspanPair(fontSize, smallFontSize, point.z, "Z")));
};